import { Component } from '@angular/core';
import { AppSettings } from '../../../app.config';
import { CoreService } from '../../../services/core.service';
import { OptionsState } from 'src/app/store-ngxs/states/options.state';
import { Store } from '@ngxs/store';

@Component({
  selector: 'app-branding',
  templateUrl: './branding.component.html',
  styleUrls: ['./branding.component.scss'],
})
export class BrandingComponent {
  options: AppSettings;

  constructor(private store: Store, private settings: CoreService) {
    // Get initial options from CoreService (includes sidenavCollapsed)
    this.options = this.settings.getOptions();

    // Subscribe to store options (theme, activeTheme)
    this.store.select(OptionsState.options).subscribe((storeOptions) => {
      this.options = { ...this.options, ...storeOptions };
    });

    this.settings.notify.subscribe((coreOptions: any) => {
      this.options = { ...this.options, ...coreOptions };
    });
  }
}
